import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import React, { useEffect, useState } from "react";
import withReduxProvider from "web/react/redux-provider";
import Baustein from "web/react/components/baustein/baustein";
import shopHeaderTemplate from "templates/modules/shop/shop_header.jinja";
import profileHeaderTemplate from "templates/modules/profile_header.jinja";
import BrandAdContainer from "web/react/components/brand-ad-container/brand-ad-container";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./profile-header.css";

interface ProfileHeaderBausteinProps {
    designerLogoOnSmallScreens: boolean;
    isShopHeader?: boolean;
    profile: {
        features?: {
            pmt_brand_ads?: boolean;
        };
        brand_ad?: {
            banner_image: string;
            brand_logo: string;
            brand_name: string;
            link: string;
            mpu_image: string;
            product_image?: string;
            product_link?: string;
            product_description?: string;
        };
    };
    appBannerIsVisible: boolean;
}

export function ProfileHeaderBaustein({
    designerLogoOnSmallScreens,
    isShopHeader,
    profile,
    appBannerIsVisible,
}: ProfileHeaderBausteinProps): JSX.Element {
    const [showBrandAd, setShowBrandAd] = useState<boolean>(false);
    useEffect(() => {
        if (
            profile.features &&
            profile.features.pmt_brand_ads &&
            !analytics.isAppBannerEnabled() &&
            !appBannerIsVisible
        ) {
            setShowBrandAd(true);
            analytics.event("brand_ads", "impression", "perf_brand_ad", true);
        }
    }, [profile.features, appBannerIsVisible]);

    return (
        <>
            {isShopHeader && (
                <Baustein
                    className={classnames({ [styles.bigDesign]: designerLogoOnSmallScreens })}
                    template={shopHeaderTemplate}
                    args={{ shop_header: profile }}
                />
            )}
            {!isShopHeader && (
                <section
                    className={classnames(
                        "profile-header page-block pb-spacer--desktop pos-rel cf",
                        {
                            [styles.bigDesign]: designerLogoOnSmallScreens,
                            [styles.pmt477HeaderContainer]: showBrandAd,
                        }
                    )}
                >
                    <Baustein
                        className="profile-header--compact-layout"
                        template={profileHeaderTemplate}
                        args={{ profile_header: profile }}
                    />
                    {profile.brand_ad && showBrandAd && (
                        <BrandAdContainer
                            bannerImage={profile.brand_ad.banner_image}
                            brandLogo={profile.brand_ad.brand_logo}
                            brandName={profile.brand_ad.brand_name}
                            link={profile.brand_ad.link}
                            mpuImage={profile.brand_ad.mpu_image}
                            productImage={profile.brand_ad.product_image}
                            productLink={profile.brand_ad.product_link}
                            productDescription={profile.brand_ad.product_description}
                        />
                    )}
                </section>
            )}
        </>
    );
}

export default withReduxProvider(ProfileHeaderBaustein);
